module.exports = __webpack_public_path__ + "static/media/logos_squares_Gold_Alliance.5dd66227.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_Gold_Alliance.png
// module id = 81
// module chunks = 0